<div class="floating-admin">
	<div class="input-group">
		<select [(ngModel)]="store" class="form-select" (change)="submit()">
			<option [ngValue]="store" *ngFor="let store of stores">
				{{ store.apiUrl }}
			</option>
		</select>
		<a class="btn btn-outline-secondary bg-white" [href]="'https://' + store?.apiUrl + '/admin'">
			<ng-icon name="phosphorStorefront"></ng-icon>
		</a>
	</div>
</div>
